import React from "react";
import { Helmet } from "react-helmet";
import endpoints from "../../content/endpoints";
import { useState, useEffect, useRef, useCallback } from "react";
import Pagination from "../../components/Pagination/Pagination";
import Carousel from "../../components/Carousel";

import "./style.sass";

const NossaGente = () => {
  const getInitialPage = () => {
    const params = new URLSearchParams(window.location.search);
    const page = parseInt(params.get("page") || "1", 10);
    return isNaN(page) || page < 1 ? 1 : page;
  };

  const sectionRef = useRef(null);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(getInitialPage);
  const [totalPages, setTotalPages] = useState(null);

  const handlePageChange = (page) => {
    setCurrentPage(page);

    const section = sectionRef.current;

    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const fetchData = useCallback(
    (url, currentPage) => {
      fetch(`${url}?page=${currentPage}`)
        .then((res) => res.json())
        .then((data) => {
          const mappedData = data.data.map((item) => {
            const thumbImage = {
              id: 0,
              url: item.imagem,
              legend: "Imagem principal",
            };

            item.galeria = [thumbImage, ...item.galeria];

            return item;
          });

          setData(mappedData);

          if (totalPages === null) {
            setTotalPages(data.total);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    [setTotalPages, setData, totalPages]
  );

  const updateUrlParam = useCallback(
    (page) => {
      const url = new URL(window.location.href);
      url.searchParams.set("page", page);

      window.history.pushState({}, "", url);

      fetchData(endpoints.nossa_gente, page);
    },
    [fetchData]
  );

  useEffect(() => {
    updateUrlParam(currentPage);
  }, [currentPage, updateUrlParam]);

  return (
    <main className="NossaGente">
      <div ref={sectionRef} className="NossaGente__ref"></div>
      <Helmet>
        <title>Nossa Gente | FRIBAL - Especialistas em Carne</title>
      </Helmet>
      <section className="NossaGente__content">
        <h2 className="NossaGente__title">Nossa Gente</h2>
        <div className="NossaGente__container">
          {Array.isArray(data) &&
            data.map((item) => {
              return (
                <section key={item.id} className="NossaGente__projeto">
                  <h3 className="NossaGente__subtitle title">{item.titulo}</h3>
                  <div className="NossaGente__description">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.texto || "",
                      }}
                    />
                  </div>
                  <div className="NossaGente__image">
                    <Carousel slides={item.galeria} options={{}} />
                  </div>
                </section>
              );
            })}
        </div>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      </section>
    </main>
  );
};

export default NossaGente;
